<ng-template componentLoader></ng-template>